import { useFormik } from "formik"
import { verify } from "jsonwebtoken"
import React, { useEffect, useState } from "react"
import PhoneInput from "react-phone-input-2"
import "react-phone-input-2/lib/bootstrap.css";
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom"

import {
  Alert,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap"
import * as Yup from "yup"
import { addNewPartner } from "../../store/clients/actions";
const PartnerRegistration = () => {
  const { token } = useParams()
  const dispatch = useDispatch()
  const [notMatching, setNotMatching] = useState(false)
  const success = useSelector(state => state?.Login?.success)
  const [auth, setAuth] = useState(null)
  const [phone_code, setPhone_code] = useState('+961')
  useEffect(() => {
    token &&
      verify(token, "7ufFO*xbCxYXURy&G#Nj", (err, decoded) => {
        !err ? setAuth(decoded) : setAuth({ err: true })
      })
  }, [token])

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      first_name: "",
      last_name: "",
      email: auth?.email.trim().toLowerCase(),
      phone: '',
      password: "",
      confirmPassword: "",
    },
    // validationSchema: Yup.object({
    //   first_name: Yup.string().required("Your first name is required"),
    //   last_name: Yup.string().required("Your last name is required"),
    //   email: Yup.string()
    //     .email("enter a valid email")
    //     .required("Email is required"),
    //   password: Yup.string().required("Please Enter Your new password"),
    //   confirmPassword: Yup.string()
    //     .oneOf([Yup.ref("password")], "Password not matching")
    //     .required("Please Enter Your confirm Password"),
    // }),
    onSubmit: values => {

        let data = {
            first_name :values.first_name,
            last_name :values.last_name,
            email :values.email.trim().toLowerCase(),
            phone :values.phone,
            phone_code,
            password :values.password,
            event_id:auth.event_id,
            client_id:auth.client_id,
            token
        }
        dispatch(addNewPartner(data))
      }
    
  })

  const { error } = useSelector(state => ({
    error: state.Login.error,
  }))
  const loading = useSelector(state => state.clients.loading)
  useEffect(() => {
    document.body.className = "authentication-bg"
    return function cleanup() {
      document.body.className = ""
    }
  })

  return !auth ? (
    <Spinner type="grow" className="m-1" color="primary" />
  ) : (
    <div className="account-pages my-5 pt-sm-5">
      <Container>
        <Row className="align-items-center justify-content-center">
          <Col md={8} lg={6} xl={5}>
            <Card>
              <CardBody className="p-4">
                <div className="text-center mt-2">
                  <h5 className="text-primary">{!auth?.err && auth.client_id == 0 ? `Welcome Back !` : !auth?.err && auth.client_id != 0 ? `Accept your invitation` : null}</h5>
                  <p className="text-muted">{!auth?.err && auth.client_id == 0 ? `` : !auth?.err && auth.client_id != 0 ? `` : null}</p>
                </div>
                {auth?.err ? (
                  <Alert color="danger">{"Not Authorized"}</Alert>
                ) : null}
                {!auth?.err && auth.client_id == 0 ? (
                  <div className="p-2 mt-4">
                    <Form
                      className="form-horizontal"
                      onSubmit={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      {error ? <Alert color="danger">{error}</Alert> : null}
                      {validation.errors.confirmPassword ? (
                        <Alert color="danger">{"Password not matching"}</Alert>
                      ) : null}
                      <div className="mb-3">
                        <Label className="form-label">First Name</Label>
                        <Input
                          name="first_name"
                          className="form-control"
                          placeholder="First Name"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.first_name || ""}
                          invalid={
                            validation.touched.first_name && validation.errors.first_name
                              ? true
                              : false
                          }
                        />
                        {validation.touched.first_name && validation.errors.first_name ? (
                          <FormFeedback type="invalid">
                            {validation.errors.first_name}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">Last name</Label>
                        <Input
                          name="last_name"
                          className="form-control"
                          placeholder="Last Name"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.last_name || ""}
                          invalid={
                            validation.touched.last_name && validation.errors.last_name
                              ? true
                              : false
                          }
                        />
                        {validation.touched.last_name && validation.errors.last_name ? (
                          <FormFeedback type="invalid">
                            {validation.errors.last_name}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email
                              ? true
                              : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">
                            {validation.errors.email}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <Row className="mb-3">
                        <Label className="form-label">
                                    Phone
                                  </Label>
                      <Col className="col-5">   
                                  <PhoneInput
                                  inputStyle={{width:'100%',height:30}}
                                  country={"eg"}
                                    enableSearch={true}
                                    value={phone_code}
                                    onChange={(phone) => setPhone_code('+'+phone)}
                                  />
                                </Col>
                                <Col className="col-7">
                                  <Input
                          name="phone"
                          className="form-control"
                          placeholder="Phone"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.phone || ""}
                          invalid={
                            validation.touched.phone && validation.errors.phone
                              ? true
                              : false
                          }
                        />
                        {validation.touched.phone && validation.errors.phone ? (
                          <FormFeedback type="invalid">
                            {validation.errors.phone}
                          </FormFeedback>
                        ) : null}
                                </Col>
                      
                      </Row>

                      <div className="mb-3">
                        <Label className="form-label">New password</Label>
                        <Input
                          name="password"
                          className="form-control"
                          placeholder="Enter password"
                          type="password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.password || ""}
                          invalid={
                            validation.touched.password &&
                            validation.errors.password
                              ? true
                              : false
                          }
                        />
                        {validation.touched.password &&
                        validation.errors.password ? (
                          <FormFeedback type="invalid">
                            {validation.errors.password}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Confirm Password</Label>
                        <Input
                          name="confirmPassword"
                          value={validation.values.confirmPassword || ""}
                          type="password"
                          placeholder="Enter confirmPassword"
                          onChange={e => {
                            setNotMatching(false)
                            validation.setFieldValue(
                              "confirmPassword",
                              e.target.value
                            )
                          }}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.confirmPassword &&
                            validation.errors.confirmPassword
                              ? true
                              : false
                          }
                        />
                        {validation.touched.confirmPassword &&
                        validation.errors.confirmPassword ? (
                          <FormFeedback type="invalid">
                            {validation.errors.confirmPassword}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mt-3 d-flex justify-content-center flex-nowrap">
                        {loading ? (
                          <Spinner
                            type="grow"
                            className="m-1"
                            color="primary"
                          />
                        ) : (
                          <button
                            className="btn btn-primary w-100 waves-effect waves-light"
                            type="submit"
                            // disabled={loading}
                          >
                            Save
                          </button>
                        )}
                      </div>
                    </Form>
                  </div>
                ) : !auth?.err && auth.client_id != 0 ? 
                <Form
                className="form-horizontal"
                onSubmit={e => {
                  e.preventDefault()
                  validation.handleSubmit()
                  return false
                }}
              >
                <div className="mt-3 d-flex justify-content-center flex-nowrap">
                {loading ? (
                  <Spinner
                    type="grow"
                    className="m-1"
                    color="primary"
                  />
                ) : (
                  <button
                    className="btn btn-primary w-100 waves-effect waves-light"
                    type="submit"
                    // disabled={loading}
                  >
                    Accept
                  </button>
                )}
              </div>
                 </Form>
              :null
              }
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default PartnerRegistration
